import cls from './GiftBlock.module.css';
import { Flex, Icon, UiButton, UiText } from '@shared/ui';
import React from 'react';
import { getPluralized } from '@shared/helpers';
import { useTranslation } from 'react-i18next';

export const GiftBlock = ({ days, onActionClick }: { days: number; onActionClick: () => void }) => {
    const { t } = useTranslation();
    const pluralizedDaysText = getPluralized(Number(days), {
        one: t('WidgetShop.paymentModal.trial.dayWord.dayOne'),
        few: t('WidgetShop.paymentModal.trial.dayWord.daysFew'),
        many: t('WidgetShop.paymentModal.trial.dayWord.daysMany'),
    });

    return (
        <Flex className={cls.TrialWrapper} justify={'between'}>
            <Flex gap={10}>
                <Icon iconName={'gift'} />
                <Flex direction={'column'} align={'start'} gap={2}>
                    <UiText weight={'semibold'}>
                        {pluralizedDaysText} {t('WidgetShop.paymentModal.trial.title')}
                    </UiText>
                    <UiText>{t('WidgetShop.paymentModal.trial.subTitle')}</UiText>
                </Flex>
            </Flex>

            <UiButton
                className={cls.TrialConnectBtn}
                variant={'text'}
                btnText={t('WidgetShop.paymentModal.trial.btnText')}
                endIcon={
                    <Icon iconName={'carouselNext'} fill={'currentColor'} width={10} height={10} />
                }
                onClick={onActionClick}
            />
        </Flex>
    );
};
